<template>
  <v-app>
    <v-toolbar app>
      <span>
        <v-menu offset-y>
          <v-btn slot="activator" icon light>
            <v-icon>menu</v-icon>
          </v-btn>
            <v-list>
            <v-list-tile v-for="(item, index) in items" :key="index" :to="item.target">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
            </v-list>
        </v-menu>
      </span>
      <v-toolbar-title class="headline text-uppercase">
        <span>MAS </span>
        <span class="font-weight-light">Re:mote Thermocouple Monitoring</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon light @click="goHome">
          <v-img :src="require('./assets/core-temp-icon.svg')" height="45" width="45"></v-img>
        </v-btn>
      
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      items: [
      { title: 'Home', target: '/home' },
      { title: 'Kiln Data', target: '/data' },
      { title: 'Firings', target: '/firings' },
      { title: 'Realtime', target: '/realtime' },
      { title: 'Notifications', target: '/notifications' },
      { title: 'Logout', target: '/logout' }
    ]
    }
  },
    methods: {
        goHome () {
            var target;
            if(this.authenticated == false) {
                target = "login";
            } else {
                target = "home";
            }
            this.$router.replace({ name: target });
        }
    },
    computed: {
        ...mapState([
            'authenticated',
            'loggedInUser'
        ])
    },
    mounted() {
        if(this.authenticated == false) {
            this.$router.replace({ name: "login" });
        }
    }
}
</script>
